module.exports = __webpack_public_path__ + "static/media/add-image.3c700331.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/add-image.svg
 ** module id = 1258
 ** module chunks = 0
 **/